import React from 'react'
import { PopupProps } from '../popup'
import SelectWrap from '../selectWrap'
import SingleOptions from './SingleOptions'
import { SelectSingleProps } from './interface'

const SelectSingle = <V = unknown, >(props: SelectSingleProps<V> & PopupProps) => {
  const { value, onChange, disabled, ...selectProps } = props

  return (
    <SelectWrap<V>
      value={value}
      onChange={onChange}
      disabled={disabled}
      {...selectProps}
    >
      {({ onClose, visible }) => (
        <SingleOptions
          value={value}
          onChange={(ev) => {
            if (!ev.keepOpen) {
              onClose?.()
            }
            onChange?.(ev)
          }}
          visible={visible}
          disabled={typeof disabled === 'boolean' ? undefined : disabled}
          {...selectProps}
        />
      )}
    </SelectWrap>
  )
}

export default SelectSingle
